import * as React from 'react';
import Button from '@mui/material/Button';
import { useState, useEffect } from "react";
import { useToken } from '../items/UseToken';




export default function KillJobButton(props) {

    const [jobGuid, setJobGuid] = useState("");
    const { token } = useToken()

    useEffect(() => {
        console.log(props.guid)
        setJobGuid(props.guid)
    }, []);

    function handleOnClick() {
        const requestOptions = {
            method: 'POST',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token,
            },
            body: JSON.stringify({ guid: jobGuid })
        };
        fetch('api/killjob', requestOptions);
    }

    return (
       
        <Button color="error" onClick={handleOnClick}>
                        Kill
                    </Button>
                    
           
    );
}
